import SueldoInteligente1 from "../assets/sueldoInteligente1.png";
import Hero1 from "../components/Hero1";
import HorizontalList from "../components/horizontalList";
import Section1 from "../components/sueldoInteligente/Section1";
import Section2 from "../components/sueldoInteligente/Section2";
import img1 from "../assets/sueldoInteligente/carousel/1.png";
import img2 from "..//assets/sueldoInteligente/carousel/2.png";
import img3 from "../assets/sueldoInteligente/carousel/3.png";
import img4 from "../assets/sueldoInteligente/carousel/4.png";
import img5 from "../assets/sueldoInteligente/carousel/5.png";
import Carousel from "../components/carousel";
import Section3 from "../components/sueldoInteligente/Section3";
import Section4 from "../components/sueldoInteligente/Section4";

export default function SueldoInteligente() {
    return (
        <div className="overflow-x-hidden">
            <Hero1 
                titulo="Sueldo inteligente" 
                descripcion={
                    "Recibe el dinero de tus giros o remesas directamente en tu Cuenta de MEU, sin hacer filas y al instante.\n¡Activa el Abono Automático y disfruta de tu dinero con total confianza!"
                }
                imagen={SueldoInteligente1}
                botonTexto="Comienza ahora"
            />
            <HorizontalList
              items={[
                { label: "Beneficios", targetId: "beneficios" },
                { label: "Características", targetId: "caracteristicas" },
                { label: "Activación", targetId: "activacion" },
                { label: "Tasas y tarifas", targetId: "tasas" },
                { label: "Documentos", targetId: "documentos" },
                { label: "Preguntas frecuentes", targetId: "faq" },
              ]}
            />
            <section id="beneficios" className="scroll-mt-24">
              <Section1 />
            </section>
            <section id="caracteristicas" className="scroll-mt-24">
              <Section2 />
            </section>
            <section id="activacion" className="scroll-mt-24">
              <Carousel
              items={[
                {
                  titulo: "Paso 1: Accede",
                  imagen: img1,
                  descripcion: "Ingresa a la plataforma de MEU Personas utilizando tu usuario y contraseña."
                },
                {
                  titulo: "Paso 2: Elige la opción",
                  imagen: img2,
                  descripcion: "En el menú principal, selecciona la sección de Transferencias y luego la opción de Internacionales para hacer clic en \"Recibir\"."
                },
                {
                  titulo: "Paso 3: Activa el abono automático",
                  imagen: img3,
                  descripcion: "En el menú principal, selecciona la sección de Transferencias y luego la opción de Internacionales para hacer clic en \"Recibir\"."
                },
                {
                  titulo: "Paso 4: Selecciona la cuenta",
                  imagen: img4,
                  descripcion: "Elige la cuenta en la que deseas recibir el abono y selecciona el motivo del giro."
                },
                {
                  titulo: "Paso 5: Confirma",
                  imagen: img5,
                  descripcion: "Revisa la información y haz clic en \"Activar el abono automático\". Finalmente, deberías ver un mensaje confirmando que la activación fue exitosa."
                }
              ]}
            />
            </section>
            <section id="tasas" className="scroll-mt-24">
              <Section3 />
            </section>
            <section id="documentos" className="scroll-mt-24">
              <Section4 />
            </section>
        </div>
    );
}
